import { useEffect, useState } from 'react';

/** A ticking clock so heat, the spine's "now" marker and SLA labels stay live. */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}

export function untilLabel(target: number, now = Date.now()): string {
  const diff = target - now;
  const past = diff < 0;
  const mins = Math.round(Math.abs(diff) / 60000);
  let s: string;
  if (mins < 60) s = `${mins}m`;
  else if (mins < 1440) s = `${Math.floor(mins / 60)}h ${mins % 60}m`;
  else s = `${Math.floor(mins / 1440)}d ${Math.floor((mins % 1440) / 60)}h`;
  return past ? `${s} over` : s;
}
